import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useStore } from '../lib/store';

export default function Toasts() {
  const toasts = useStore(s => s.toasts);
  const removeToast = useStore(s => s.removeToast);
  return (
    <div className="toast-container">
      <AnimatePresence>
        {toasts.map(t => (
          <motion.div
            key={t.id}
            className={`toast toast-${t.type || 'info'}`}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, x: 40 }}
            transition={{ duration: 0.2 }}
          >
            <span style={{ flex: 1 }}>{t.msg}</span>
            <button
              onClick={() => removeToast(t.id)}
              className="toast-dismiss"
              aria-label="Dismiss notification"
              style={{
                background: 'none',
                border: 'none',
                color: 'inherit',
                opacity: 0.5,
                cursor: 'pointer',
                padding: '0 0 0 0.75rem',
                fontSize: '1rem',
                lineHeight: 1,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
